import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { Stack } from "../Stack";
import React, { forwardRef } from 'react';
export var Nav = forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Stack, _extends({
    "aria-orientation": "vertical",
    as: "nav",
    gap: 8,
    ref: forwardedRef
  }, other), children);
});